import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid";
import RoomIcon from '@material-ui/icons/Room';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneIcon from '@material-ui/icons/Phone';

const useStyles = makeStyles((theme) => ({
    ol: {
        fontSize: '12px',
        paddingLeft: '20px',
        '& ol': {
            paddingInlineStart: '20px',
        },
        '& .lower-alpha': {
            listStyleType: 'lower-alpha',
        },
        '& .lower-roman': {
            listStyleType: 'lower-roman',
        },
        '& li': {
            marginBottom: '6px',
        },
    },
    p: {
        fontSize: '20px',
    },
    RoomIcon:{
        fontSize: '10px',
        color:'black',
    }
}));

const ContactUs = () => {
    const classes = useStyles();

    return (
        <section
            style={{
                minHeight: 'inherit',
                color: 'black',
                margin: '0 auto',
                padding: '20px',
                maxWidth: '1024px',
                backgroundColor: '#f05b83',

            }}
        >
            <center>
                <img src='/logo.png' alt='logo' width='90px' height='90px' className={classes.logoImg} />
            </center>

            <h1 style={{textAlign: 'center',fontSize:'24px'}}>Contact Us</h1>
            <main>
                <p style={{fontSize: '20px'}}>
                    <MailOutlineIcon fontSize={'small'}></MailOutlineIcon><b> Email : </b>barun@neuu.in<br/><br/>
                    <PhoneIcon fontSize={'small'}></PhoneIcon><b> Phone :</b>8951359305<br/>
                </p>
                <p className={classes.p}>
                    <RoomIcon color={'black'} fontSize={'small'}></RoomIcon>
                    <span fontSize={'20px'}> Office Address:<br/></span>
                    Barun Kumar Ghadia,  <br/>
                    Survey no.56/13, Hosur Rd, near Sai Baba Temple, <br/>
                    Garvebhavi Palya,<br/>
                    Bengaluru, Karnataka 56006<br/>
                </p>
                <p className={classes.p}>
                <b>Map :</b><br/><br/>
                <center>
                    <iframe 
	    		src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.2346026363102!2d77.6329061740942!3d12.892630687415526!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae14b99c7ff5f1%3A0x724133e6c6953ef0!2sST.Mary&#39;s%20High%20School!5e0!3m2!1sen!2sin!4v1736140448149!5m2!1sen!2sin"
	    		width="450px" height="450px" loading="lazy">
                    </iframe>
                </center>
                </p>
                <p className={classes.p} style={{fontSize: '14px'}}>
	    	    <center>
                        <a href={'/'}>Home</a> | <a href={'/aboutus'}>About Us</a> | <a href={'/contactus'}>Contact Us</a>  | <a href={'/terms-and-conditions'}>Terms</a> | <a href={'/shipping'}>Shipping</a>
	            </center>
                </p>
            </main>
        </section>
    );
};
export default ContactUs;
